import { useEffect, useRef, useState } from "react";
import { CheckCircle2 } from "lucide-react";

const TOAST_DURATION_MS = 3000;

export function useSaveToast() {
  const [message, setMessage] = useState("");
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const show = (nextMessage: string) => {
    if (timeout.current) clearTimeout(timeout.current);
    setMessage(nextMessage);
    timeout.current = setTimeout(() => {
      setMessage("");
      timeout.current = null;
    }, TOAST_DURATION_MS);
  };

  const clear = () => {
    if (timeout.current) clearTimeout(timeout.current);
    timeout.current = null;
    setMessage("");
  };

  useEffect(
    () => () => {
      if (timeout.current) clearTimeout(timeout.current);
    },
    [],
  );

  return { message, show, clear };
}

export function SaveToast({ message }: { message: string }) {
  if (!message) return null;
  return (
    <div
      aria-live="polite"
      className="fixed left-1/2 top-4 z-[100] flex -translate-x-1/2 items-center gap-2 rounded-xl border border-emerald-200 bg-white px-5 py-3 font-bold text-emerald-900 shadow-xl"
      role="status"
    >
      <CheckCircle2 aria-hidden="true" className="text-emerald-700" size={20} />
      {message}
    </div>
  );
}
